import { render } from "./ViewOrder.vue?vue&type=template&id=1153c7f8&scoped=true"
import script from "./ViewOrder.vue?vue&type=script&lang=js"
export * from "./ViewOrder.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=1153c7f8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1153c7f8"]])

export default __exports__